import { Icons } from './icons';
export const DSMappedIcon = ({ icon, className }) => {
    var _a;
    const clean = icon === null || icon === void 0 ? void 0 : icon.trim().replace(/\s\s+/g, ' ');
    if (!clean) {
        return null;
    }
    const isNotIconPathFormat = clean.split(' ').length !== 2;
    if (isNotIconPathFormat) {
        return null;
    }
    const [group, name] = clean.split(' ');
    const svgComponent = (_a = Icons[group]) === null || _a === void 0 ? void 0 : _a[name];
    return svgComponent ? svgComponent({ className }) : null;
};
//# sourceMappingURL=dsIcon.js.map